export const LOADING_FAILED = 'LOADING_FAILED'
export const LOADING_SUCCESS = 'LOADING_SUCCESS'
export const LANGUAGE_TEXT_LIVE = 'LANGUAGE_TEXT_LIVE'
export const SET_LANGUAGE_TEXT = 'SET_LANGUAGE_TEXT'
export const EVENT_ID = 'EVENT_ID'
export const SET_SUBMIT_FORM = 'SET_SUBMIT_FORM'
export const ADD_USER_DETAILS = 'ADD_USER_DETAILS'
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS'